import { ComboBoxItemTypeS } from "../../atoms/ComboBox/ItemComboBoxStr"
import dayjs from 'dayjs';
import { ResponceDataType } from "../../../ErrorCode";
import { LogD } from "../../../function/LogLapper";

export type SelectDataType = {
  devIndex: string; //選択機器番号
  selectDate: string; //選択日時
  selectTime: string; //選択時間
};

/**
 * オフライン判定データ
 */
export type OfflineJudgeDataType = {
  DEV_INDEX?: number;  /// 機器 INDEX を取得または設定します
  DEV_NO: string;  ///  機器番号を取得または設定します
  DEV_NAME: string;  ///  機器名称を取得または設定します
  PLC_NO: number;  ///PLCNo. を取得または設定します
  AI_CARD: number;  ///AI カード No. を取得または設定します
  AI_CH: number;  /// CHNo. を取得または設定します
  SET_NO?: number;  /// センサー No. を取得または設定します
  SPEED: number;  /// 低速/高速区分を取得または設定します
  NAME_NO: number;  /// 名称 No を取得または設定します
  MES_NAME: string;  /// 計測種別を取得または設定します
  ITM_NAME_NO: number;  /// 項目名称 No を取得または設定します
  ITM_NAME: string;  /// 項目名称を取得または設定します
  AppModeSelect:number; ///アプリモード選択(1:オンプレミス 2:クラウド)
};

/**
 * グラフ表示アイテム
 */
export type GraphDispSetting = {
  yMin: number; ///y軸最小値
  yMax: number; ///y軸最大値
  xMin: number; ///x軸最小値
  xMax: number; ///x軸最大値
  isPileup: boolean;
  isDCRemoval: boolean;
};

export type GraphSetting = {
  upper: number;
  upperLimit: number;
  yMin: number; ///y軸最小値
  yMax: number; ///y軸最大値
  xMin: number; ///x軸最小値
  xMax: number; ///x軸最大値
  backColor: string;
  memoryFontColor: string;
  yUnit: string;
  xUnit: string;
  yUnitColor: string;
  xUnitColor: string;
  gridColor: string;
};

export type GraphData = {
  lineNo: number;
  lineName: string;
  points: GraphPoint[];
  valueUpper: number;
  valueUpperLimit: number;
  selectFlg: boolean;
  infoColor: string;
};

export type GraphPoint = {
  xValue: number;
  yValue: number;
};

// export type MeasureInfoType = {
//   AiCard: number; //AIカード
//   AiCh: number; //CH番号
//   DevIndex: number; //機器インデックス
//   DevName: string;  //機器名称
//   DevNo: string;  //機器番号
//   ItemName: string; //項目名称
//   ItemNameNo: number; //項目名称 No
//   KindNo: number; //計測種別 No
//   LogStart: string; //ロギング開始時刻
//   MesName: string;  //計測種別
//   PlcNo : number; //PLC 番号
//   FftInvalid : number;  //FFT項目非表示フラグ
//   SetNo: number;  //設定No
//   Speed: number;  //低速/高速区分

  
//   name: string;
//   id: number;
//   selectDay: string;
//   selectTime: string;
//   EntryNo: number;  //PLCユニット登録No
// };

export type LineInfo = {
    FileName: string;
    MaxValue: number;
    MinValue: number;
    YaxisOffset: number;
    XaxisStartIndex: number;
    XaxisSpanCount: number;
    SamplingRate: number;
    XValues: number[];
  YValues: number[];
  UnitSymbol: string;
  ItemName: string;
};


export type OffLineJudgeComparisonData = {
    LineData: LineInfo;
    YaxisMax: number;
    YaxisMin: number;
    XaxisMax: number;
    XaxisMin: number;
}

/**
 * オフライン判定デバイス情報尾取得
 * @returns 
 */
export const GetOffLineJudgeData = (): Promise<OfflineJudgeDataType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/OfflineJudge/")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: OfflineJudgeDataType[]) => {
        if (result != null) {
          if (result.length !== 0) {
            console.debug(["GetOffLineJudgeData - ok",result]);
          }
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error.status);
        console.error(error);
        reject(error);
      })
  })
};

/**
 * オフライン判定データのファイル時間リストを取得
 * @param devIndex
 * @param date
 * @returns
 */
export const GetOffLineJudgeFileTimes = (devIndex : string , date : string ): Promise<Date[]> => {
  return new Promise((resolve, reject) => {

    const query_params = new URLSearchParams({
      devIndex: devIndex,
      selectDate: date
    });

    console.debug(["GetOffLineJudgeFileTimes - ulr","api/OfflineJudge/GetTime?" + query_params])
    fetch("api/OfflineJudge/GetTimes?" + query_params)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: Date[]) => {
        if (result != null) {
          if (result.length !== 0) {
            console.debug(["GetOffLineJudgeFileTimes - ok",result]);
          }
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

/**
 * オフライン判定データをコピー
 * @param devIndex 
 * @param date 
 * @param startTime 
 * @param endTime 
 * @param saveFlg 
 * @returns 
 */
export const ExecuteCopyOffLineJudgeFile = (devIndex : string , date : string ,startTime:string,endTime:string,saveFlg:boolean): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    const url = `api/OfflineJudge/CopyExecute?devIndex=${devIndex}&&selectDate=${date}&&startTime=${startTime}&&endTime=${endTime}&&saveFlg=${saveFlg}`;
   
    console.debug(["ExecuteCopyOffLineJudgeFile - ulr",url]);
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: ResponceDataType) => {
        if (result != null) {
            console.debug(["ExecuteCopyOffLineJudgeFile - ok",result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param settings OfflineJudgeデータリスt
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateDevCombBoxItems = (offlineJudgeData: OfflineJudgeDataType[]) : ComboBoxItemTypeS[]=>{
  let comboItems: ComboBoxItemTypeS[] = [];

  //重複削除
  const unique = offlineJudgeData.filter(
  (element, index, self) => self.findIndex((e) => e.DEV_INDEX === element.DEV_INDEX) === index
);
  unique.forEach((r) => {
    if (r.DEV_INDEX != null) {
    let item: ComboBoxItemTypeS = {
      key :r.DEV_INDEX.toString(),
      name : `${r.DEV_NO} ${r.DEV_NAME}`
    }
    comboItems.push(item);
    }
  });
  return comboItems;
};

/**
 *　画面で使用するコンボボックスアイテムリストを作成
 * @param settings FileTimeリスト
 * @param nameDevSets NameDevSetリスト
 * @returns コンボボックスリスト
 */
export const CreateTimeCombBoxItems = (fileTimes: Date[]) : ComboBoxItemTypeS[]=>{
  let comboItems: ComboBoxItemTypeS[] = [];

  fileTimes.forEach((r) => {
    const item: ComboBoxItemTypeS = {
      key :dayjs(r).format('HH:mm:ss'),
      name : dayjs(r).format('HH:mm:ss')
    }
    comboItems.push(item);
  });

  return comboItems;
};

/**
 * グラフデータ取得
 * @param plcNo 
 * @param aiNo 
 * @param chNo 
 * @param targetDay 
 */
export const GetOffLineJudgeGraphLineData = (plcNo: number, aiNo: number, chNo: number, targetDay: string): Promise<OffLineJudgeComparisonData> => {
  console.debug("-OffLineJudge Get GraphLineData exec- ");

  const url = `api/OfflineJudge/GetGraphLineData?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
      fetch(url)
      .then((res) => res.json())
        .then((result: OffLineJudgeComparisonData) => {
          console.debug(result);
          if (GraphLineDataValidate(result)) resolve(result);
          reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
    );
    });
  }

  const GraphLineDataValidate = (data: OffLineJudgeComparisonData) => {
      LogD(`GraphLineDataValidate ckeck ${data}`,true);
      if (data == undefined) return false;
        LogD("GraphLineDataValidate ckeck ok",true);
      return true;
  };